import React from 'react';
import "./Header.css"

const AuthHeader = () => {
    return (
        <header className="d-flex justify-content-center align-items-center p-1 border-bottom" style={{ backgroundColor: '#fff' }}>
            <div className="d-flex align-items-center">
                <a href="/">
                    <img
                        src="/images/logo-Cplatform.png"
                        alt="Logo"
                        width="210"
                        height="60"
                        className="d-inline-block align-top me-2"
                    />
                </a>
            </div>
        </header>
    );
};

export default AuthHeader;
